// extracted by mini-css-extract-plugin
export default {"head":"About_head__LGTvm","content":"About_content__Kb6y5","mission":"About_mission__EwcG0","listelements":"About_listelements__IqoOC","listgap":"About_listgap__3YAZC"};